import { BrowserRouter } from "react-router-dom";
import { Routes } from "./routes";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./styles/theme";

export default function App() {
  return (
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <Routes />
      </ChakraProvider>
    </BrowserRouter>
  );
}
